import "../collections/slots.js";
import "./slot.js";
import "./base.js";

// This will be used to contain the slot information

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotSuggester ??= {};
window.AppointmentBooking.SlotSuggester.Models ??= {};

AppointmentBooking.SlotSuggester.Models.SlotStack = class SlotStack extends (
  AppointmentBooking.SlotSuggester.Models.Base
) {
  static {
    this.prototype.relations = [
      {
        // Slots suggested for the currently selected date
        type: Backbone.HasMany,
        key: "slots",
        relatedModel: "AppointmentBooking.SlotSuggester.Models.Slot",
        collectionType: "AppointmentBooking.SlotSuggester.Collections.Slots",
      },
    ];

    // CONVENIENCE PROPERTIES
    this.get("slotCount", function () {
      return this.get("slots").length;
    });
  }

  static createAll(slots, options = {}) {
    const map = {};
    slots.forEach((slot) => {
      let slotStack;
      const startTime = slot.get("startTime");

      if (!(slotStack = map[startTime])) {
        slotStack = new this({ startTime });
        map[startTime] = slotStack;
      }

      return slotStack.get("slots").add(slot);
    });

    let stacks = Object.values(map);

    // Prioritize stacks closest to the desired time if one is given
    if (options.desiredStartTime != null) {
      const desiredStartMoment = moment(options.desiredStartTime);
      stacks = _.sortBy(stacks, (stack) => Math.abs(moment(stack.get("startTime")).diff(desiredStartMoment)));
    }

    if (options.limit != null) {
      stacks = _.first(stacks, options.limit);
    }

    return new AppointmentBooking.SlotSuggester.Collections.Base(stacks, { comparator: "startTime" });
  }

  constructor() {
    super(...arguments);
    this.toJSON = this.toJSON.bind(this);
    this.buildSlotText = this.buildSlotText.bind(this);
    this.contains = this.contains.bind(this);
  }

  defaults() {
    return {
      startTime: null,
      desiredTimeSlot: false, // True if this was the user's originally requested time slot
      slots: [],
    };
  }

  // RENDERING

  toJSON(options) {
    const json = super.toJSON(options);
    if (!this.get("text")) {
      json.text = this.buildSlotText();
    }

    return json;
  }

  // HELPER METHODS

  buildSlotText() {
    if (this.slotCount === 1) {
      return this.get("slots").first().get("provider").get("name");
    } else {
      return `${this.slotCount} Providers`;
    }
  }

  contains(predicate) {
    return this.get("slots").findWhere(predicate) != null;
  }
};
